import { ReactNode } from 'react';

import type { InteractiveSubActivityFragment } from '../../lesson-builder.graphql.generated';
import { ComponentSubActivity } from '../component.constants';
import { Settings } from 'approot/shared/richtext/richtext.constants';

export const SUB_ACTIVITY_INSTRUCTION_SETTINGS: Settings = {
  canChangeBlockType: true,
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: true,
  canChangeHistory: false,
  canChangeFonts: true,
  canAddLinks: true,
  canAlignText: true,
  canHighlight: true,
  placeholder: 'Add question',
};

export type EditProps = {
  id: string;
  children: (container: HTMLDivElement | null) => ReactNode;
  subActivityDetails: InteractiveSubActivityFragment | null;
  component: Omit<ComponentSubActivity, 'subActivityProperties'>;
};

export type ViewProps = {
  children?: ReactNode;
  subActivityDetails: InteractiveSubActivityFragment | null;
  componentId?: string;
  componentType?: string;
  withTTSButton?: boolean;
  ariaLabel?: string;
  onClick?: () => void;
};
